export enum MmdmIntegrationStatus {
    NOT_AVAILBLE = 0,
    IN_PROGRESS = 1,
    SUCCESS = 2,
    ERROR_RECEIVE_DATA = 3,
    ERROR_PROCESS_DATA = 4
}
